import React from 'react';

const AuthenticationWithEnable = (Component) => (props) => (props.userStore.getAuthenticationList()[props.authenticationKey] ? <Component {...props} /> : props.h1 && <h1>{props.h1}</h1> || <></>);

export default AuthenticationWithEnable;
